<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "tour-work-order-index",
}
</script>

<style scoped>

</style>